import { render, staticRenderFns } from "./InjectionErrors.vue?vue&type=template&id=73c61618&"
import script from "./InjectionErrors.vue?vue&type=script&lang=js&"
export * from "./InjectionErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports